export default {
  title: 'Supplier Quotation Template',
  standardTag: 'System Standard',
  status: {
    enabled: 'Enabled',
    disabled: 'Disabled',
    all: 'All'
  },
  templateTypes: {
    PREPORT: 'Pre-port',
    LASTMILES: 'Last Mile',
    SEA: 'Sea',
    AIR: 'Air',
    RAIL: 'Rail',
    EXPRESS: 'Express',
    FCL: 'Ocean FCL',
    LCL: 'Ocean LCL',
    AIR_FCL: 'Air FCL',
    AIR_LCL: 'Air LCL'
  },
  fieldTypes: {
    text: 'Text',
    select: 'Select',
    date: 'Date',
    number: 'Number',
    fee: 'Fee',
    'fee-section': 'Fee Table',
    'field-group': 'Field Group',
    'date-range': 'Date Range',
    'suggest-multi': 'Multi Suggest',
    weekdays: 'Weekdays',
    suggest: 'Suggest',
    checkbox: 'Checkbox'
  },
  fieldTypesShort: {
    text: 'Text',
    select: 'Select',
    date: 'Date',
    number: 'Number',
    fee: 'Fee',
    'fee-section': 'Fee Table',
    'date-range': 'Date Range',
    'suggest-multi': 'Multi',
    weekdays: 'Weekdays',
    suggest: 'Suggest',
    checkbox: 'Check'
  },
  common: {
    query: 'Search',
    reset: 'Reset',
    save: 'Save',
    cancel: 'Cancel',
    back: 'Back',
    edit: 'Edit',
    detail: 'Detail',
    delete: 'Delete',
    retry: 'Retry',
    required: 'Required',
    optional: 'Optional',
    visible: 'Visible',
    hidden: 'Hidden',
    locked: 'Locked',
    selected: 'Selected',
    loadFailed: 'Load failed',
    saveFailed: 'Save failed'
  },
  list: {
    create: 'New Template',
    keyword: 'Template Name',
    keywordPlaceholder: 'Enter template name/No.',
    templateType: 'Business Type',
    status: 'Status',
    noSupplierNeeded: 'No binding needed (default fallback)',
    goAssociate: 'Bind',
    associateSuppliers: 'Bind Suppliers',
    deleteConfirm: 'Delete this template? Bound suppliers will be released automatically. This cannot be undone.',
    empty: 'No templates',
    columns: {
      templateNo: 'Template No.',
      templateName: 'Template Name',
      templateType: 'Business Type',
      fieldCount: 'Fields',
      suppliers: 'Suppliers',
      status: 'Status',
      updatedAt: 'Updated At',
      actions: 'Actions'
    },
    messages: {
      enabled: 'Enabled',
      disabled: 'Disabled',
      deleted: 'Deleted',
      standardCannotDelete: 'System standard template cannot be deleted'
    },
    confirm: {
      enable: 'Enable this template?',
      disableStandard: 'After disabling, suppliers without custom templates cannot use the standard template. Continue?',
      disableWithSuppliers: 'This template is bound to {count} supplier(s). They will be unable to use it after disabling. Continue?',
      disable: 'Disable this template?'
    }
  },
  create: {
    back: 'Back',
    editTitle: 'Edit Quotation Template',
    createTitle: 'New Quotation Template',
    save: 'Save',
    cancel: 'Cancel',
    previewTitle: 'Form Preview',
    sharedFields: 'Shared Fields',
    previewEmpty: 'Select business type and modules to preview',
    basicInfo: 'Basic Info',
    templateName: 'Template Name',
    templateNameRequired: 'Please enter template name',
    templateNamePlaceholder: 'e.g. Shenzhen Export FCL Quotation',
    templateNo: 'Template No.',
    autoGenerate: 'Auto generated',
    statusRequired: 'Please select status',
    businessTypeTitle: 'Business Type',
    businessTypeRequired: 'Please select business type',
    businessTypeImmutable: 'Business type cannot be changed after creation',
    modulesTitle: 'Template Modules (optional)',
    modulesRequired: 'Select at least one module',
    modulesHint: 'Modules depend on business type; all selected by default',
    typesTitle: 'Template Types',
    typesTitleMulti: 'Template Types (multi-select)',
    typesRequired: 'Select at least one template type',
    selectedPrefix: 'Selected: ',
    selectType: 'Select business type',
    selectModules: 'Select template modules',
    standardTypeLocked: 'Standard template type cannot be changed',
    typeImmutable: 'Template type cannot be changed after creation',
    selected: 'Selected',
    fieldConfig: 'Field Configuration',
    fieldConfigTip: 'Use arrows to reorder. Switches control required/optional and visibility. Locked fields cannot be changed.',
    selectTypeFirst: 'Select business type and modules first',
    keepOneType: 'Keep at least one module',
    changeBusinessTitle: 'Change business type',
    changeBusinessContent: 'Changing business type will reset modules and fields. Continue?',
    unselectTypeTitle: 'Remove module',
    unselectTypeContent: 'Removing "{typeLabel}" will clear its field configuration. Continue?',
    loadDefaultFieldsFailed: 'Failed to load default fields',
    templateNotFound: 'Template not found',
    selectAtLeastOneType: 'Select at least one module',
    updated: 'Template updated',
    created: 'Template created',
    leaveTitle: 'Leave page?',
    leaveContent: 'Unsaved changes will be lost. Continue?'
  },
  detail: {
    back: 'Back to list',
    title: 'Template Detail: {templateName}',
    loading: 'Loading template...',
    loadFailed: 'Load failed',
    retry: 'Retry',
    basicInfo: 'Basic Info',
    systemLocked: 'System Locked',
    custom: 'Custom',
    requiredFees: 'Required Fees',
    noRequiredFees: 'No required fees',
    noConfig: 'No configuration',
    suppliers: 'Bound Suppliers',
    noSuppliers: 'No bound suppliers',
    fieldCount: '{count}',
    supplierCount: '{count}',
    labels: {
      templateNo: 'Template No.',
      templateName: 'Template Name',
      businessType: 'Business Type',
      templateTypes: 'Template Modules',
      status: 'Status',
      fieldCount: 'Fields',
      supplierCount: 'Suppliers',
      createdAt: 'Created At',
      updatedAt: 'Updated At'
    },
    columns: {
      fieldCode: 'Field Code',
      fieldName: 'Field Name',
      fieldType: 'Field Type',
      locked: 'Lock Status',
      sortOrder: 'Sort',
      options: 'Options'
    },
    notFound: 'Template not found'
  },
  quotationList: {
    title: 'Supplier Quotations',
    supplier: 'Supplier',
    supplierPlaceholder: 'Enter',
    templateType: 'Template Type',
    submitted: 'Submitted',
    abandoned: 'Abandoned',
    viewDetail: 'View Detail',
    columns: {
      quotationNo: 'Quotation No.',
      templateName: 'Template Name',
      status: 'Status',
      submittedAt: 'Submitted At',
      actions: 'Actions'
    }
  },
  quotationDetail: {
    back: 'Back to list',
    title: 'Quotation Detail',
    basicInfo: 'Basic Info',
    quotationNo: 'Quotation No.',
    supplier: 'Supplier',
    templateName: 'Template Name',
    templateType: 'Template Type',
    status: 'Status',
    submitted: 'Submitted',
    abandoned: 'Abandoned',
    submittedAt: 'Submitted At',
    content: 'Quotation Content',
    empty: 'No quotation data'
  },
  supplierH5: {
    title: 'Supplier Quotation',
    loaded: 'Template loaded',
    templateLabel: 'Template: {templateName}',
    supplierSuffix: '· {supplierName}',
    fieldsTitle: 'Quotation Fields',
    pleaseInput: 'Enter {fieldName}',
    pleaseSelect: 'Select {fieldName}',
    pleaseFill: 'Fill in {fieldName}',
    submit: 'Submit',
    saveDraft: 'Save Draft',
    loadFailed: 'Load failed',
    loadFailedDesc: 'Unable to load quotation template. Please check the link.',
    reload: 'Reload',
    linkInvalid: 'Quotation link is invalid or expired',
    submitted: 'Quotation submitted',
    submitFailed: 'Submit failed',
    draftSaved: 'Draft saved',
    saveFailed: 'Save failed'
  },
  fieldConfigurator: {
    selectedFields: 'Selected Fields',
    fieldConfig: 'Field Configuration',
    fieldCount: '{count} fields',
    sort: 'Sort',
    fieldName: 'Field Name',
    required: 'Required',
    sharedFields: 'Shared Fields',
    locked: 'Locked',
    switchOptional: 'Set optional',
    switchRequired: 'Set required',
    requiredLabel: 'Required',
    optionalLabel: 'Optional',
    switchHidden: 'Hide',
    switchVisible: 'Show',
    requiredFees: 'Required Fees',
    feeCount: '{count}',
    feePlaceholder: 'Search and select fee items',
    feeTip: 'Select fees from master data; fee IDs will be saved',
    empty: 'No fields'
  },
  association: {
    title: 'Bind Suppliers — {templateName}',
    searchPlaceholder: 'Search supplier name...',
    added: 'Added',
    add: 'Add',
    notFound: 'No suppliers found',
    noAvailable: 'No available suppliers',
    associatedCount: 'Bound suppliers ({count})',
    noneAssociated: 'No bound suppliers',
    unbindConfirm: 'Unbind this supplier?',
    templateIncomplete: 'Incomplete template info',
    standardNoBind: 'Standard template does not need manual supplier binding',
    saved: 'Bindings saved'
  },
  preview: {
    pleaseInput: 'Enter {fieldName}',
    pleaseSelect: 'Please select',
    selectDate: 'Select date',
    pleaseEnter: 'Please enter',
    startDate: 'Start date',
    endDate: 'End date',
    searchSelect: 'Search & select',
    searchOrInput: 'Search or enter',
    weekdays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    currency: 'Currency',
    amount: 'Amount',
    readonly: 'Readonly',
    noSubFields: 'No sub-fields'
  },
  api: {
    catalogEmpty: 'Field catalog is empty. Please initialize first.',
    noTemplateTypes: 'Template has no business types. Cannot bind suppliers.'
  }
}
